

export default {

    props: {
        mode: {
            type: String,
            default: '',
            required: true
        },
        action: {
            type: String,
            default: '',
            required: false
        },
        groupId: {
            type: Number,
            default: 0,
            required: false
        }
    },
    components: {
    },

    created() {
        let t = this;

        t.loadData();
    },
    activated() {
        let t = this;
    },
    methods: {
        loadData() {
            let t = this;

            axios.get('im/getContacts?_with=grant').then(res => {
                if (res.data.status == 1) {

                    let employees = res.data.options.employees;

                    employees.forEach(item => {
                        item.selected = false;
                        item.type = 1;
                        t.list.employee.push(item);
                    });

                    t.dict.employee = listToDict(employees);

                    if (t.groupId) {
                        axios.get('chatGroup/' + t.groupId + '?_with=employee').then(res => {
                            if (res.data.status == 1) {
                                let group = res.data.options.item;

                                group.count_read = 0;
                                group.count_member = 0;

                                if (group.notice_read_employee_ids) {
                                    group.count_read = group.notice_read_employee_ids.split(',').length;
                                }

                                if (group.member_ids) {
                                    let memberIds = group.member_ids.split(',');
                                    group.count_member = memberIds.length;

                                    memberIds.forEach(memberId => {
                                        if (t.dict.employee[memberId])
                                            t.list.member.push(t.dict.employee[memberId]);
                                    });

                                }

                                if (group.support_ids) {
                                    let supportIds = group.support_ids.split(',');
                                    supportIds.forEach(memberId => {
                                        if (t.dict.employee[memberId])
                                            t.dict.employee[memberId].type = 2;
                                    });

                                }

                                t.group = group;

                                copyFrom(t.f, t.group);

                                if (t.action == 'addMember') {
                                    t.showAddMember = true;
                                }
                            }
                        });
                    }
                }
            });


        },
        back() {
            let t = this;
            if (t.backConfirm) {
                A.safety('変更が保存されていません。ページを離れてもよろしいですか？').then(res => {
                    if (res.isConfirmed) {
                        t.$emit('back');
                    }
                });
            }
            else {
                t.$emit('back');
            }
        },
        clearAllMsg() {
            let t = this;

            A.safety('すべてのチャット履歴を削除しますか？この操作は取り消せません。').then(res => {
                if (res.isConfirmed) {
                    axios.post('chatGroup/clearAllMsg/' + t.group.id).then(res => {
                        if (res.data.status == 1) {
                            t.$emit('clean');
                            A.toast('すべてのチャット履歴が削除されました');
                        }
                    });
                }
            });
        },
        exportCSV() {
            let t = this;
            A.err('CSVのエクスポート機能は現在ご利用いただけません。');
        },
        saveGroup() {
            let t = this;

            let f = t.f;

            if (!f.name) {
                A.err('グループ名を入力して下さい。');
                return;
            }

            if (f.notice || f.notice_en || f.notice_cn) {
                if (!f.notice || !f.notice_en || !f.notice_cn) {
                    A.err('すべての言語に対して通知内容を入力してください。');
                    return;
                }
            }

            let arr = [t.U.id];

            let supportIds = [];
            t.list.member.forEach(item => {
                arr.push(item.id);
                if (item.type == 2) {
                    supportIds.push(item.id);
                }
            });

            f.member_ids = arr.join(',');
            f.support_ids = supportIds.join(',');

            if (t.group) {
                axios.put('chatGroup/' + t.group.id, f).then(res => {
                    if (res.data.status == 1) {
                        A.toast('Saved.');
                        t.$emit('group-change');
                        t.backConfirm = false;
                    }
                    else if (res.data.status == -2) {
                        A.err('同名のグループは既に存在します。');
                    }
                });
            }
            else {
                axios.post('chatGroup', f).then(res => {
                    if (res.data.status == 1) {
                        A.toast('Saved.');
                        t.backConfirm = false;
                        let group = res.data.options.item;

                        if (group.support_ids) {
                            let supportIds = group.support_ids.split(',');
                            if (supportIds.includes(t.U.id.toString())) {
                                group.isSupport = true;
                            }
                        }
                        t.group = group;
                        t.$emit('group-change');
                    }
                    else if (res.data.status == 0) {
                        A.err('同名のグループは既に存在します。');
                    }
                });
            }


        },

        saveMembers() {

            let t = this;

            let arr = [];

            t.list.employee.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                    t.list.member.push(item);
                    item.selected = false;
                }
            });

            t.showAddMember = false;

            t.backConfirm = true;
        },


        saveSupports() {

            let t = this;

            let count = t.list.member.filter(item => item.selected).length;

            if (count > 3) {
                A.err('サポートを最大3人まで設定できます。');
                return;
            }

            t.list.member.forEach(item => {
                if (item.selected) {
                    item.selected = false;
                    item.type = 2;
                }
                else {
                    item.type = 1;
                }
            });

            t.showAddSupport = false;

            t.backConfirm = true;
        },

        uploadAvatar() {

            let t = this;

            t.uploadImgType = 'avatar';

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById('cropperImg2');

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 1 / 1,
                        autoCropArea: 1,
                        crop(event) {
                        },
                    });
                    $('#cropperItem_groupAvatar').show();
                }

                event.target['value'] = '';


            };

            ImageUploader.openSelector();
        },

        closeCropper() {
            $('.cropper-item').hide();
        },

        confirmCropper() {

            let t = this;

            t.cropper.getCroppedCanvas({
                minHeight: 600,
                minWdith: 600,
                maxHeight: 1000,
                maxWdith: 1000,
                fillColor: '#fff',
            }).toBlob((blob) => {

                let fd = new FormData();

                fd.append('image', blob);

                t.backConfirm = true;

                axios.post('chatGroup/saveImage', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
                    if (res.data.status == 1) {
                        t.f.avatar_url = res.data.options.img_url;
                    }
                });

                t.closeCropper();
            });
        },

        removeMembers() {
            let t = this;

            let arr = [];

            t.list.member.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                    item.selected = false;
                }
            });
            arr.forEach(item => {
                t.list.member.remove(item);
            });

            t.showRemoveMember = false;

            t.backConfirm = true;

        },

        removeSupports() {
            let t = this;

            t.list.member.forEach(item => {
                if (item.selected && item.type == 2) {
                    item.selected = false;
                    item.type = 1;
                }
            });

            t.showRemoveSupport = false;

            t.backConfirm = true;


        },

        clearNotice() {
            let t = this;
            if (t.translator.lang == 'jp') {
                t.f.notice = '';
            }
            else {
                t.f['notice_' + t.translator.lang] = '';
            }
            t.backConfirm = true;
        },
        scrollToBottom() {
            this.$nextTick(() => {
                let e = document.querySelector('.member-items._top');
                e.scrollTop = e.scrollHeight;
            });
        },

        readNotice() {
            let t = this;

            axios.get('chatGroup/readNotice/' + t.group.id).then(res => {
                if (res.data.status == 1) {
                    t.group.count_read++;
                    t.back();
                }
            });

        },
        selectManager(member) {

            let t = this;

            let arr = t.selectedMembers;

            arr.forEach(member => {
                member.selected = false;
            });

            member.selected = true;
        },
        setAsManager() {

            let t = this;

            if (t.selectedMembers.length == 0) {
                A.err('メンバーを1人選択してください');
                return;
            }

            axios.put('chatGroup/' + t.group.id, { 'employee_id': t.selectedMembers[0].id }).then(res => {
                if (res.data.status == 1) {
                    A.toast('Saved.');
                    t.group.employee_id = t.selectedMembers[0].id;
                    t.$emit('transfered', t.group.employee_id);
                    t.back();
                }
            });
        },
        goAddSupport() {
            let t = this;
            t.showAddSupport = true;
            t.list.member.forEach(item => {
                if (item.type == 2) {
                    item.selected = true;
                }
            });
        },

        goRemoveSupport() {
            let t = this;
            t.list.member.forEach(item => {
                item.selected = false;
            });
            t.showRemoveSupport = true
        },
    },
    data() {
        return {
            showTransfer: false,
            backConfirm: false,
            group: null,
            search: {
                keywords: ''
            },
            showAddSupport: false,
            showRemoveSupport: false,

            showAddMember: false,
            showRemoveMember: false,
            translator: {
                lang: 'jp'
            },
            f: {
                'name': '',
                'avatar_url': '',
                'notice': '',
                'notice_en': '',
                'notice_cn': '',
            },
            dict: { employee: {} },
            list: {
                employee: [],
                member: [],
            }
        };
    },
    computed: {

        supportMembers() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (item.type == 2) {
                    arr.push(item);
                }
            });
            return arr;
        },

        normalMembers() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (item.type == 1) {
                    arr.push(item);
                }
            });
            return arr;
        },

        selectedSupports() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },

        unselectedSupports() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (!item.selected) {
                    if (t.search.keywords) {
                        if (item.name.indexOf(t.search.keywords) > -1) {
                            arr.push(item);
                        }
                    }
                    else {
                        arr.push(item);
                    }
                }
            });

            return arr;
        },

        selectedSupportMembers() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (item.type == 2 && item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },

        unselectedSupportMembers() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (item.type == 2 && !item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedMembers() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },
        unselectedMembers() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (!item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedCleanMgrs() {
            let t = this;
            let arr = [];


            t.list.member.forEach(item => {
                if (item.is_mgr == 1 || item.grant.clean_mgr == 1) {
                    if (item.selected) {
                        arr.push(item);
                    }
                }
            });

            return arr;
        },
        unselectedCleanMgrs() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                if (item.is_mgr == 1 || item.grant.clean_mgr == 1) {
                    if (!item.selected) {
                        arr.push(item);
                    }
                }
            });

            return arr;
        },

        allMembers() {
            let t = this;
            let arr = [];

            t.list.member.forEach(item => {
                arr.push(item);
            });

            t.list.employee.forEach(item => {
                if (item.selected && arr.indexOf(item) == -1) {
                    arr.push(item);
                }
            });

            return arr;
        },
        selectedEmployees_filtered() {

            let t = this;
            let arr = [];

            t.list.employee.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },
        notInGroup() {
            let t = this;
            let arr = [];

            t.list.employee.forEach(item => {

                if (t.list.member.indexOf(item) > -1 || item.selected) {
                    return;
                }

                if (t.search.keywords) {
                    if (item.name.indexOf(t.search.keywords) > -1) {
                        arr.push(item);
                    }
                }
                else {
                    arr.push(item);
                }
            });

            return arr;
        },
        toRemoveMembers() {
            return [];
        },

    }
};
